import React from "react";
import { Container } from "reactstrap";
import PeriscopeDashboard from "@/components/periscopeDashboard/PeriscopeDashboard";

const Dashboard = () => (
  <Container>
    <PeriscopeDashboard />
  </Container>
);

export default Dashboard;
